<template>
  <div>
    <v-card v-if="Loading" color="yellow lighten-2">
      <v-card-text>
        <h3>Cargando</h3>
        <h3>Por Favor Espere...</h3>
      </v-card-text>
      <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <v-card :color="fondoEstado" v-if="!Loading">
      <v-app-bar color="cyan lighten-4" dense elevation="0">
        <v-toolbar-title>Orden De Laboratorio </v-toolbar-title>
        <span class="pl-16"
          >Estado: {{ estado }}
          <span v-if="motivoEstado"> motivo: {{ motivoEstado }} </span>
        </span>
      </v-app-bar>
      <v-card-text>
        <v-row>
          <v-col md="9">
            <v-card class="my-1" elevation="4">
              <v-card-text class="light-blue lighten-4">
                <v-row no-gutters>
                  <v-col md="4">
                    <v-text-field
                      style="max-width: 220px;"
                      type="date"
                      dense
                      hide-details
                      outlined
                      label="Fecha de Prescripcion"
                      v-model="autorizacion.fechaprescripcion"
                      clearable
                    >
                    </v-text-field>
                    <div v-if="!autorizacion.fechaprescripcion">
                      FECHA INVALIDA
                    </div>
                  </v-col>
                  <v-col md="4" class="light-blue lighten-4">
                    <v-checkbox
                      v-model="rechazar"
                      label="Rechazar automáticamente" v-if="!efectorlogueado"
                    >
                    </v-checkbox>
                    <Combo
                      id_estado="4"
                      v-if="rechazar"
                      v-model="autorizacion.id_motivo"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="my-1" elevation="4">
              <v-col class="teal lighten-4">
                Diagnostico:
                <span class="pl-6" v-if="diagnostico">
                  {{ diagnostico.Problema }}
                  <v-btn icon>
                    <v-icon color="red" @click="diagnostico = undefined">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </span>
              </v-col>
              <v-card-text v-if="!diagnostico">
                <v-row no-gutters>
                  <v-col md="6">
                    <AutocompletarDiagnostico
                      v-model="diagnostico"
                      v-if="!diagnostico"
                    ></AutocompletarDiagnostico>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="my-1" elevation="4">
              <v-col class="light-blue lighten-4">
                Prescriptor
                <span class="pl-6" v-if="prescriptor">
                  {{ prescriptor.nombreefector }} ({{ prescriptor.RAZON_SOCI }})
                  <v-btn icon>
                    <v-icon color="red" @click="prescriptor = undefined">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </span>
              </v-col>
              <v-card-text v-if="!prescriptor">
                <v-row no-gutters>
                  <v-col md="12">
                    <busquedaefector
                      altaPrescriptor
                      v-model="prescriptor"
                    ></busquedaefector>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="my-1" elevation="4">
              <v-col class="teal lighten-4">
                Prestador
                <v-btn color="secondary" x-small dark depressed v-if="!efectorlogueado"
                  @click="traerSinEfector()"
                >Sin prestador</v-btn>
                <span class="pl-6" v-if="efector">
                  {{ efector.nombreefector }} ({{ efector.RAZON_SOCI }})
                  <v-btn icon>
                    <v-icon color="red" @click="efector = undefined">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                  <domicilio
                    :id_efector="efector.Id"
                    v-model="autorizacion.id_domicilioprofesional"
                  ></domicilio>
                </span>
              </v-col>
              <v-card-text v-if="!efector">
                <v-row no-gutters>
                  <v-col md="12">
                    <busquedaefector
                      :id_plan="id_plan"
                      v-model="efector"
                    ></busquedaefector>
                    <busquedaefectorProvincia
                      :id_plan="id_plan"
                      v-model="efector"
                    ></busquedaefectorProvincia>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="my-1" elevation="4">
              <v-col class="light-blue lighten-4">
                Laboratorios
              </v-col>
              <v-card-text>
                <v-row no-gutters>
                  <v-col md="12">
                    <AutocompletarNomenclador
                      v-model="nuevo_labo"
                    ></AutocompletarNomenclador>
                  </v-col>
                  <v-col md="12">
                    <v-card
                      v-for="linea in listalineas"
                      :key="linea.id_linealaboratorio"
                    >
                      <v-card-text>
                        <v-row no-gutters>
                          <v-col md="10">
                            {{ linea.practica.cod_nom }} -
                            {{ linea.practica.des_nom }}
                          </v-col>
                          <v-col md="2">
                            <v-btn icon>
                              <v-icon
                                color="red"
                                @click="
                                  eliminarLinea(linea.id_linealaboratorio)
                                "
                              >
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="my-1" elevation="4">
              <v-col class="light-blue lighten-4">
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      label="Observacion"
                      class="ml-2"
                      background-color="grey lighten-3"
                      v-if="!readonly"
                      dense
                      hide-details
                      outlined
                      v-model="nuevaObservacion"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      label="Observacion Interna"
                      class="ml-2"
                      background-color="grey lighten-3"
                      v-if="!readonly && !efectorlogueado"
                      dense
                      hide-details
                      outlined
                      v-model="nuevaObservacionInterna"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
          </v-col>
          <v-col md="3">
            <Imagenes :IdImagenes="autorizacion.idimagenes"></Imagenes>
            <desestimar
              v-model="autorizacion.desestimarpatologias"
              :patologias="patologias"
            ></desestimar>
            <v-btn @click="Guardar()" :disabled="GuardarDisabled">
              Guardar
            </v-btn>
            <h4>{{ motivoDisabled }}</h4>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
const ID_PRACTICA = process.env.VUE_APP_ID_PRACTICA_LABORATORIO

import AutocompletarDiagnostico from '@/components/Diagnostico/Autocompletar'
import AutocompletarNomenclador from '@/components/Lineas_Laboratorio/Autocompletar'
import busquedaefector from '@/components/Efectores/Autocomplete'
import busquedaefectorProvincia from '@/components/Efectores/PorProvincia'
import Imagenes from '@/components/Practica/Imagenes'
import domicilio from '@/components/Efectores/Domicilios'
import { mapActions, mapMutations, mapState } from 'vuex'
import desestimar from '@/components/Patologias/Desestimar'
import Combo from '@/components/Motivos/Combo'
import LUM from '@/lib/LUM'
import API from '@/lib/API'
export default {
  props: {
    id_afiliado: Number,
    id_plan: Number,
    patologias: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
    efectorlogueado: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rechazar: false,
      motivoDisabled: '',
      id_linea: 0,
      Loading: false,
      motivoEstado: '',
      diagnostico: undefined,
      nuevo_labo: 0,
      efector: undefined,
      prescriptor: undefined,
      efectorprofesional: undefined,
      listalineas: [],
      nuevaObservacion: '',
      nuevaObservacionInterna: '',
      autorizacion: {
        id_solic: 0,
        id_afiliado: 0,
        fechaprescripcion: '',
        fechaprogramada: '',
        idproblema: 0,
        problema: '',
        id_practica: ID_PRACTICA,
        cantidad: 1,
        id_efector: 0,
        id_efectorprofesional: 0,
        id_prescriptor: 0,
        tipo: 4,
        estado: 1,
        idimagenes: 0,
        desestimarpatologias: false,
      },
    }
  },
  computed: {
    ...mapState('imagenespracticas', { listadocumentos: 'Lista' }),
    GuardarDisabled() {
      let ret = false
      let mot = ''
      if (
        !this.listadocumentos ||
        this.listadocumentos.length == 0 ||
        !this.autorizacion.fechaprescripcion ||
        !this.diagnostico ||
        !this.efector ||
        this.listalineas.length == 0
      ) {
        ret = true
        if (!this.listadocumentos || this.listadocumentos.length == 0) {
          mot += '* Imagen obligatoria'
        }
        if (!this.autorizacion.fechaprescripcion) {
          mot += '* fecha de prescripcion obligatoria'
        }
        if (!this.diagnostico) {
          mot += '* diagnostico obligatorio'
        }
        if (!this.efector) {
          mot += '* prestador obligatorio'
        }
        if (this.listalineas.length == 0) {
          mot += '* practicas obligatorias'
        }
      }
      this.motivoDisabled = mot
      return ret
    },
    estado() {
      if (this.rechazar) {
        this.autorizacion.estado = 4
        this.motivoEstado = ''
      } else {
        this.autorizacion.estado = 1
      }
      let ret = 'Sin Evaluar'
      switch (this.autorizacion.estado) {
        case 1:
          ret = 'Pendiente'
          break
        case 2:
          ret = 'Autorizado'
          break
        case 3:
          ret = 'En Gestion'
          break
        case 4:
          ret = 'Rechazado'
          break
        case 5:
          ret = 'Cerrado'
          break
        default:
          break
      }
      return ret
    },
    fondoEstado() {
      let ret = 'lime lighten-4'
      switch (this.autorizacion.estado) {
        case 1:
          ret = 'red'
          break
        case 2:
          ret = 'green'
          break
        case 3:
          ret = 'blue'
          break
        case 4:
          ret = 'black'
          break
        case 5:
          ret = 'white'
          break
        default:
          break
      }
      return ret
    },
    autorizacion_cantidad() {
      return this.autorizacion.cantidad
    },
    hoy() {
      return LUM.datetoYYYYMMDD(new Date())
    },
    autorizacion_fechaprescripcion() {
      return this.autorizacion.fechaprescripcion
    },
  },
  methods: {
    ...mapMutations('comun', ['mostrar']),
    ...mapActions('autorizaciones', ['modificarEntidad']),
    ...mapActions('lineaslaboratorio', { modificarlinea: 'guardarEntidad' }),

    evaluarCantidad() {
      if (!this.autorizacion.cantidad) {
        this.autorizacion.cantidad = 1
        // this.evaluarEstado();
      }
    },
    eliminarLinea(id_linea) {
      this.listalineas = this.listalineas.filter(
        (x) => x.id_linealaboratorio != id_linea
      )
    },
    async Guardar() {
      let prac = { ...this.autorizacion }
      delete prac.Areas
      delete prac.Beneficiarios
      delete prac.Diagnosticos
      delete prac.Efector
      delete prac.EfectorProfesional
      delete prac.Prescriptor
      delete prac.baso001
      delete prac.Prescriptor
      delete prac.Derivaciones
      delete prac.Estados
      delete prac.Observaciones
      delete prac.ObservacionesInternas
      delete prac.Lineas_Laboratorio
      delete prac.Lineas

      this.Loading = true
      prac.estado = this.autorizacion.estado
      this.autorizacion = await this.modificarEntidad(prac)

      delete this.listalineas.Estados

      this.listalineas.forEach((x) => {
        ;(x.id_solic = this.autorizacion.id_solic), (x.id_linealaboratorio = 0)
        if (this.rechazar) {
          x.estado = 4
        } else {
          x.estado = 1
        }
        this.modificarlinea(x)
      })
      if (this.nuevaObservacion) {
        await API.Observaciones.alta({
          id: 0,
          id_solic: this.autorizacion.id_solic,
          observacion: this.nuevaObservacion,
          id_usuario: 0,
        })
      }
      if (this.nuevaObservacionInterna) {
        await API.ObservacionesInternas.alta({
          id: 0,
          id_solic: this.autorizacion.id_solic,
          observacion: this.nuevaObservacionInterna,
          id_usuario: 0,
        })
      }
      this.$emit('practicaGuardada')
      this.resetear()
      this.Loading = false
    },
    async traerSinEfector() {
      this.efector = await API.Efector.traerUno(1)
    },
    resetear() {
      this.motivoEstado = ''
      this.diagnostico = undefined
      this.efector = undefined
      this.prescriptor = undefined
      this.efectorprofesional = undefined
      this.autorizacion.id_solic = 0 //autorizacion= {
      //this.autorizacion.id_afiliado = 0;
      this.autorizacion.fechaprescripcion = ''
      this.autorizacion.fechaprogramada = ''
      this.autorizacion.idproblema = 0
      this.autorizacion.problema = ''
      this.autorizacion.id_practica = ID_PRACTICA
      this.autorizacion.cantidad = 1
      this.autorizacion.id_efector = 0
      this.autorizacion.id_efectorprofesional = 0
      this.autorizacion.id_prescriptor = 0
      this.autorizacion.tipo = 4
      this.autorizacion.estado = 1
      this.autorizacion.idimagenes = new Date().getTime()
      this.autorizacion.desestimarpatologias = false
      ;(this.listalineas = []), (this.nuevaObservacion = '')
      this.nuevaObservacionInterna = ''
      this.autorizacion.id_domicilioprofesional = 0
      //};
    },
    async evaluarEstado() {
      // if (
      //   this.autorizacion.id_afiliado &&
      //   this.autorizacion.cantidad &&
      //   this.autorizacion.id_practica &&
      //   this.autorizacion.id_efector
      // ) {
      //   let estado = await API.Autorizaciones.evaluarEstado(
      //     this.autorizacion.id_afiliado,
      //     this.autorizacion.cantidad,
      //     this.autorizacion.id_practica,
      //     this.autorizacion.id_efector,
      //     this.autorizacion.id_efectorprofesional
      //   );
      //   this.autorizacion.estado = estado.idEstado;
      //   this.motivoEstado = estado.motivo;
      // }
      this.autorizacion.estado = estado.idEstado
      this.motivoEstado = ''
    },
  },
  components: {
    AutocompletarDiagnostico,
    AutocompletarNomenclador,
    busquedaefector,
    busquedaefectorProvincia,
    desestimar,
    domicilio,
    Imagenes,
    Combo,
  },
  watch: {
    nuevo_labo() {
      this.listalineas.push({
        id_linealaboratorio: this.id_linea++,
        id_solic: 0,
        id_practica: this.nuevo_labo.id,
        estado: 1,
        practica: this.nuevo_labo,
      })
    },
    autorizacion_fechaprescripcion() {
      if (this.autorizacion_fechaprescripcion) {
        if (this.autorizacion_fechaprescripcion > this.hoy) {
          this.autorizacion.fechaprescripcion = ''
          //this.autorizacion.fechaprescripcion = '2000-01-01';
          //this.mostrar("La fecha de prescripcion no puede ser mayor a hoy " + this.hoy);
        }
      }
    },
    // IdImagenes() {
    //   if (this.IdImagenes) {
    //     this.autorizacion.idimagenes = this.IdImagenes;
    //   }
    // },
    id_afiliado() {
      if (this.id_afiliado) {
        this.autorizacion.id_afiliado = this.id_afiliado
      }
    },
    autorizacion_cantidad() {
      if (
        !(
          !isNaN(parseFloat(this.autorizacion.cantidad)) &&
          isFinite(this.autorizacion.cantidad)
        )
      ) {
        this.autorizacion.cantidad = ''
      } else {
        // this.evaluarEstado();
      }
    },
    diagnostico() {
      if (this.diagnostico) {
        this.autorizacion.idproblema = this.diagnostico.IdProblema
        this.autorizacion.problema = this.diagnostico.Problema
      }
    },
    efector() {
      if (this.efector) {
        this.autorizacion.id_efector = this.efector.Id
        // this.evaluarEstado();
      }
    },
    prescriptor() {
      if (this.prescriptor) {
        this.autorizacion.id_prescriptor = this.prescriptor.Id
      }
    },
    efectorprofesional() {
      if (this.efectorprofesional) {
        this.autorizacion.id_efectorprofesional = this.efectorprofesional.Id
        // this.evaluarEstado();
      }
    },
    efectorlogueado() {
      if (this.efectorlogueado) {
        this.efector = this.efectorlogueado
        this.efectorprofesional = this.efectorlogueado
      }
    },
    // estado() {
    //   this.autorizacion.cod_nom = this.practica.cod_nom;
    // },
  },
  mounted() {
    //this.autorizacion.idimagenes = this.IdImagenes;
    this.autorizacion.idimagenes = new Date().getTime()
    this.autorizacion.id_afiliado = this.id_afiliado
    if (this.efectorlogueado) {
      this.efector = this.efectorlogueado
      this.efectorprofesional = this.efectorlogueado
    }
  },
}
</script>

<style></style>
